import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import firebase from "../../Firebase";
import { Link } from "react-router-dom";
import matchSorter from "match-sorter";
import { Card, CardBody, CardHeader, CardTitle, Row, Col } from "reactstrap";
import { Dropdown, Menu, Button } from "antd";
import StatusTag from "../../components/StatusTag/StatusTag";
import downloadFile from "../../utils/downloadFile";
import { normalizeFiles } from "../../utils/fileList";

class RegularTables extends React.Component {
  state = {
    datos: [],
    page: null,
    prof: [],
    ft: [],
    op: [],
    loading: true,
    hc: [],
    telaData: [],
  };

  async loadData() {
    await firebase
      .firestore()
      .collection("ddp")
      .orderBy("order", "desc")
      .get()
      .then((querySnapshot) => {
        const datos = [];
        querySnapshot.forEach((doc) => {
          const isEditable = doc.data().isEditable;

          datos.push({
            cliente: doc.data().cliente,
            cFechaIngreso: doc.data().cFechaIngreso,
            cFechaIngresoDdp: doc.data().fechaIngresoDdp,
            hojaConsumo: doc.data().hojaConsumo,
            hc: doc.data().hc,
            op: doc.data().op,
            cx: doc.data().cx,
            moldes: doc.data().moldes,
            moldesUrl: doc.data().moldesUrl,
            tizadoDdp: doc.data().tizadoDdp,
            tizadoDdpUrl: doc.data().tizadoDdpUrl,
            estado: [[doc.data().estado[0], doc.data().op, doc.id]],
            edit: [doc.data().edit],
            descripcion: doc.data().descripcion,
            fichaTecnica: doc.data().fichaTecnica,
            b:
              (doc.data().b !== undefined) & (doc.data().b !== [])
                ? doc.data().b[0]
                : [],
            index: [
              doc.data().estado[0],
              doc.data().op,
              !isEditable,
              doc.data().index,
            ].concat(doc.data().index),
          });
        });
        this.setState({ datos, loading: false });
      });
  }

  componentWillMount() {
    this.loadData();
  }

  borrar = (value) => {
    const op = value[1];
    const id = value[3];

    const estado = value
      .slice(0, 3)
      .map((item, idx) => (idx === 0 ? (item = "Nuevo") : item));

    firebase
      .firestore()
      .collection("comercial")
      .where("op", "==", op)
      .get()
      .then((qs) => {
        qs.forEach((doc) => {
          firebase
            .firestore()
            .collection("comercial")
            .doc(doc.id)
            .update({
              f: [],
                    });
        });
      });

    firebase
      .firestore()
      .collection("ing")
      .where("op", "==", op)
      .get()
      .then((qs) => {
        qs.forEach((doc) => {
          firebase
            .firestore()
            .collection("ing")
            .doc(doc.id)
            .update({
              fichaTecnica: "",
              b: [],
              hojaConsumo: "",
              hc: [],
              moldes: "",
              moldesUrl: "",
              tizadoDdp: "",
              tizadoDdpUrl: "",
            });
        });
      });

    firebase
      .firestore()
      .collection("ddp")
      .doc(id)
      .update({
        fichaTecnica: "",
        b: [],
        hojaConsumo: "",
        hc: [],
        moldes: "",
        moldesUrl: "",
        tizadoDdp: "",
        tizadoDdpUrl: "",
        estado,
      });

    firebase
      .firestore()
      .collection("telas")
      .where("op", "==", op)
      .get()
      .then((qs) => {
        qs.forEach((doc) => {
          firebase
            .firestore()
            .collection("telas")
            .doc(doc.id)
            .update({
              ft: "",
              b: [],
              hojaConsumo: "",
              hc: [],
              moldes: "",
              moldesUrl: "",
              tizadoDdp: "",
              tizadoDdpUrl: "",
            });
        });
      });

    firebase
      .firestore()
      .collection("corte")
      .where("op", "==", op)
      .get()
      .then((qs) => {
        qs.forEach((doc) => {
          firebase
            .firestore()
            .collection("corte")
            .doc(doc.id)
            .update({
              ft: "",
              b: [],
              hojaConsumo: "",
              hc: [],
              moldes: "",
              moldesUrl: "",
              tizadoDdp: "",
              tizadoDdpUrl: "",
            });
        });
      });

    firebase
      .firestore()
      .collection("costura")
      .where("op", "==", op)
      .get()
      .then((qs) => {
        qs.forEach((doc) => {
          firebase
            .firestore()
            .collection("costura")
            .doc(doc.id)
            .update({
              ft: "",
              b: [],
            });
        });
      });

    firebase
      .firestore()
      .collection("acabados")
      .where("op", "==", op)
      .get()
      .then((qs) => {
        qs.forEach((doc) => {
          firebase
            .firestore()
            .collection("acabados")
            .doc(doc.id)
            .update({
              ft: "",
              b: [],
            });
        });
      });

    firebase
      .firestore()
      .collection("almacen")
      .where("op", "==", op)
      .get()
      .then((qs) => {
        qs.forEach((doc) => {
          firebase
            .firestore()
            .collection("almacen")
            .doc(doc.id)
            .update({
              ft: "",
              b: [],
            });
        });
      });

    const dataUpdated = this.state.datos.map((item) => {
      if (item.op === op) {
        item.estado = [estado];
        item.index = estado.concat(id);
        item.fichaTecnica = "";
        item.b = "";
        item.hojaConsumo = "";
        item.hc = "";
        item.moldes = "";
        item.moldesUrl = "";
        item.tizadoDdp = "";
        item.tizadoDdpUrl = "";
      }
      return item;
    });

    this.setState({ data: dataUpdated });
  };

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };

  render() {
    const { datos, loading } = this.state;

    const ingPrincipal = [
      {
        headerStyle: { backgroundColor: "#7D3C98", color: "white" },
        columns: [
          {
            Header: "F. Orden de Produccion",
            headerStyle: { fontWeight: "bold", fontSize: "12px" },
            accessor: "cFechaIngreso",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "cFechaIngreso",
                  },
                ],
              }),
            filterAll: true,
          },
          {
            Header: "Fecha DDP",
            headerStyle: { fontWeight: "bold", fontSize: "12px" },
            accessor: "cFechaIngresoDdp",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "cFechaIngresoDdp",
                  },
                ],
              }),
            filterAll: true,
          },
          {
            Header: "Orden Producción",
            headerStyle: { fontWeight: "bold", fontSize: "12px" },
            width: 145,
            accessor: "op",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "op" }],
              }),
            filterAll: true,
          },
          {
            Header: "",
            accessor: "cx",
            width: 30,
            Cell: (row) => (
              <div>
                {row.value && Array.isArray(row.value) && row.value.length ? (
                  <span
                    style={{
                      width: "10px",
                      height: "100%",
                    }}
                  >
                    <a
                      href={row.value}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://cdn3.iconfinder.com/data/icons/muksis/128/pdf-128.png"
                        style={{ width: "18px" }}
                        alt=""
                      />
                    </a>
                  </span>
                ) : null}
              </div>
            ),
          },
          {
            Header: "Cliente",
            headerStyle: { fontWeight: "bold", fontSize: "12px" },
            accessor: "cliente",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  { threshold: matchSorter.rankings.CONTAINS, key: "cliente" },
                ],
              }),
            filterAll: true,
            Cell: (row) => (
              <span style={{ fontSize: "12px " }}>{row.value}</span>
            ),
          },
          {
            Header: "Ficha Técnica",
            headerStyle: { fontWeight: "bold", fontSize: "12px" },
            accessor: "fichaTecnica",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "fichaTecnica",
                  },
                ],
              }),
            filterAll: true,
          },
          {
            Header: "",
            accessor: "b",
            width: 30,
            Cell: (row) => (
              <div>
                {row.value ? (
                  <span
                    style={{
                      width: "10px",
                      height: "100%",
                    }}
                  >
                    <a
                      href={row.value}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://cdn3.iconfinder.com/data/icons/muksis/128/pdf-128.png"
                        style={{ width: "18px" }}
                        alt=""
                      />
                    </a>
                  </span>
                ) : null}
              </div>
            ),
          },
          {
            Header: "Consumo",
            headerStyle: { fontWeight: "bold", fontSize: "12px" },
            accessor: "hojaConsumo",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "hojaConsumo",
                  },
                ],
              }),
            filterAll: true,
          },
          {
            Header: "",
            accessor: "hc",
            width: 80,
            Cell: (row) => (
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {normalizeFiles(row.value, row.original.hojaConsumo).map((f, i) => (
                  <a
                    key={i}
                    href={f.url}
                    title={f.name}
                    style={{ marginRight: "4px" }}
                    onClick={(e) => {
                      e.preventDefault();
                      downloadFile(f.url, f.name);
                    }}
                  >
                    <img
                      src="https://cdn3.iconfinder.com/data/icons/muksis/128/pdf-128.png"
                      style={{ width: "18px" }}
                      alt={f.name}
                    />
                  </a>
                ))}
              </div>
            ),
          },
          {
            Header: "Moldes",
            headerStyle: { fontWeight: "bold", fontSize: "12px" },
            width: 150,
            accessor: "moldes",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "moldes",
                  },
                ],
              }),
            filterAll: true,
          },
          {
            Header: "",
            accessor: "moldesUrl",
            width: 80,
            Cell: (row) => (
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {normalizeFiles(row.value, row.original.moldes).map((f, i) => (
                  <a
                    key={i}
                    href={f.url}
                    title={f.name}
                    style={{ marginRight: "4px" }}
                    onClick={(e) => {
                      e.preventDefault();
                      downloadFile(f.url, f.name);
                    }}
                  >
                    <img
                      src="https://cdn3.iconfinder.com/data/icons/muksis/128/zip-128.png"
                      style={{ width: "18px" }}
                      alt={f.name}
                    />
                  </a>
                ))}
              </div>
            ),
          },
          {
            Header: "Tizado DDP",
            headerStyle: { fontWeight: "bold", fontSize: "12px" },
            width: 150,
            accessor: "tizadoDdp",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "tizadoDdp",
                  },
                ],
              }),
            filterAll: true,
          },
          {
            Header: "",
            accessor: "tizadoDdpUrl",
            width: 80,
            Cell: (row) => (
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {normalizeFiles(row.value, row.original.tizadoDdp).map((f, i) => (
                  <a
                    key={i}
                    href={f.url}
                    title={f.name}
                    style={{ marginRight: "4px" }}
                    onClick={(e) => {
                      e.preventDefault();
                      downloadFile(f.url, f.name);
                    }}
                  >
                    <img
                      src="https://cdn3.iconfinder.com/data/icons/muksis/128/zip-128.png"
                      style={{ width: "18px" }}
                      alt={f.name}
                    />
                  </a>
                ))}
              </div>
            ),
          },
        ],
      },
      {
        headerStyle: { backgroundColor: "#7D3C98  ", color: "white" },
        columns: [
          {
            Header: "Descripción",
            headerStyle: { fontWeight: "bold", fontSize: "12px" },
            accessor: "descripcion",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "descripcion",
                  },
                ],
              }),
            filterAll: true,
            Cell: (row) => (
              <span style={{ fontSize: "12px " }}>{row.value}</span>
            ),
          },
          {
            Header: "Estado",
            accessor: "estado",
            width: 100,
            headerStyle: { fontWeight: "bold" },
            style: { textAlign: "center" },
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  { threshold: matchSorter.rankings.CONTAINS, key: "estado" },
                ],
              }),
            filterAll: true,
            Cell: (row) => (
              <div className="text-center">
                <StatusTag status={row.value[0][0]} />
              </div>
            ),
          },
          {
            Header: "Acciones",
            headerStyle: {
              fontWeight: "bold",
              position: "sticky",
              right: 0,
              zIndex: 3,
              backgroundColor: "#f7f7f7",
              boxShadow: "-2px 0 4px rgba(0, 0, 0, 0.08)",
            },
            style: {
              position: "sticky",
              right: 0,
              zIndex: 2,
              backgroundColor: "#fff",
              boxShadow: "-2px 0 4px rgba(0, 0, 0, 0.08)",
            },
            width: 80,
            accessor: "index",
            sortable: false,
            filterable: false,
            Cell: (row) => {
              if (!row.value) {
                return "";
              }

              const eliminarDisabled =
                row.value[0] === "Nuevo" || row.value[2] ? true : false;
              const docId = row.original.estado[0][2];
              const op = row.original.op;

              const menu = (
                <Menu>
                  <Menu.Item key="edit">
                    <Link
                      to={{
                        pathname: "/Ddp/RegistroDirecto",
                        state: {
                          doc: docId,
                          op: op,
                          update: true,
                        },
                      }}
                    >
                      Editar
                    </Link>
                  </Menu.Item>
                  <Menu.Divider />
                  <Menu.Item
                    key="delete"
                    disabled={eliminarDisabled}
                    style={{ color: eliminarDisabled ? undefined : "red" }}
                    onClick={() =>
                      !eliminarDisabled &&
                      window.confirm("ESTAS SEGURO QUE QUIERES BORRAR?") &&
                      this.borrar(row.value)
                    }
                  >
                    Eliminar
                  </Menu.Item>
                </Menu>
              );

              return (
                <div className="text-center">
                  <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
                    <Button
                      className="actions-btn"
                      icon="more"
                      size="small"
                      style={{
                        fontSize: "18px",
                        color: "rgba(0, 0, 0, 0.45)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        borderColor: "#e8e8e8",
                        borderRadius: "4px",
                      }}
                    />
                  </Dropdown>
                </div>
              );
            },
          },
        ],
      },
    ];
    return (
      <div className="content">
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeader>
                <CardTitle tag="h4" className="text-center">
                  Seguimiento de Procesos DDP
                </CardTitle>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data={datos}
                  filterable
                  defaultFilterMethod={(filter, row) =>
                    String(row[filter.id]) === filter.value
                  }
                  columns={ingPrincipal}
                  noDataText="Sin Registros"
                  loading={loading}
                  loadingText="POR FAVOR, ESPERE UN MOMENTO"
                  defaultPageSize={10}
                  style={{ textAlign: "center" }}
                  getTbodyProps={() => ({ style: { overflow: "visible" } })}
                  previousText="Atras"
                  nextText="Siguiente"
                  pageText="Pagina"
                  ofText="de"
                  rowsText="filas"
                  minRows={0}
                />
                <br />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default RegularTables;
